<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="title">当前小程序id: {{ parameter.mini_program_id }}</span>

      </div>
      <div class="item">
        <span class="title">请输入广告主id:</span>
        <el-input
          v-model="parameter.account_id"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">广告主名称:</span>
        <el-input
          v-model="parameter.account_name"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <div class="item">
        <span class="title">广告主标签:</span>
        <el-input
          v-model="parameter.account_tag"
          style="width: 200px;"
          placeholder="请输入内容"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
      <!--      <el-button
        type="primary"
        icon="el-icon-circle-plus"
        @click="func"
      >添加</el-button>-->
    </div>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="id"
          label="id"
        />
        <el-table-column
          prop="account_id"
          label="广告主id"
        />
        <el-table-column
          prop="account_tag"
          label="广告主标签"
        />
        <el-table-column
          prop="account_name"
          label="广告主名称"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
        />
        <!--        <el-table-column-->
        <!--          v-if="tableData.is_admin"-->
        <!--          label="操作"-->
        <!--        >-->
        <!--          <template scope="scope">-->
        <!--            <el-button-->
        <!--              type="danger"-->
        <!--              size="mini"-->
        <!--              @click="deleteMy(scope.row)"-->
        <!--            >解绑</el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <el-dialog
      title="修改广告主"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <account @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import { delMiniAct, miniGroupActAdd, miniProgramAccount } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import Account from '@/views/TKreleaseGroup/WechatAppGroupList/sendcicle/account.vue'
export default {
  components: {
    Account,
    PaginationRight
  },
  data() {
    return {
      tableData: {},
      data: [],
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        mini_program_id: this.$route.query.id,
        account_tag: null,
        account_id: null,
        account_name: null
      },
      dialogVisible: false
    }
  },
  created() {
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList() {
      this.loading = true
      const data = await miniProgramAccount(this.parameter)
      this.tableData = data.data
      this.loading = false
    },

    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getDataList()
    },

    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDataList()
    },

    async func() {
      this.dialogVisible = true
    },

    // 重置
    reset() {
      this.parameter = {
        page: 1,
        page_size: 10,
        name: null
      }
      this.getDataList()
    },

    // 删除
    deleteMy(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        await delMiniAct({ ids: row.id })
        this.getDataList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    bandarr(val) {
      console.log(this.parameter.mini_program_id)
      console.log(val.map(item => { return item.account_id }))
      miniGroupActAdd({
        mini_program_id: this.parameter.mini_program_id,
        account_ids: val.map(item => { return item.account_id })
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('添加成功')
          this.dialogVisible = false
          this.getDataList()
        }
      })
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.selectionArea {
  display: flex;
}

.content {
  .item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.title {
  display: inline-block;
  margin-right: 10px;
}
</style>
